import { useFooterContent } from '../../../context/ContentContext';
import logoAura from '../../../assets/images/logo_aura-full.svg';
import instagramIcon from '../../../assets/images/Instagram.svg';
import './440Footer.css';

export default function Footer440() {
    const { contact, socials, copyright, legalLinks } = useFooterContent();

    return (
        <footer className="footer-440" id='footer'>
            <div className="footer-440__inner max-width">
                <div className="footer-440__aura-box">
                    <img src={logoAura} alt="440 Logo Aura" className="footer-440__aura-logo" />
                </div>

                <div className="footer-440__contact-row">
                    <a href={contact.href} className="footer-440__contact-link" target="_top">
                        {contact.label}
                    </a>
                    <div className="footer-440__socials">
                        {socials.map((social) => (
                            <a
                                key={social.platform}
                                href={social.href}
                                target="_top"
                                className="footer-440__social-link"
                                aria-label={social.platform}
                            >
                                {social.platform === 'instagram' ? (
                                    <img src={instagramIcon} alt="Instagram" className="footer-440__social-icon" />
                                ) : (
                                    <i className={`fab fa-${social.platform}`}></i>
                                )}
                            </a>
                        ))}
                    </div>
                </div>

                {/* Bottom Bar: Copyright & Legal */}
                <div className="footer-440__bottom" id="footer-bottom">
                    <p className="footer-440__copyright">© {new Date().getFullYear()} {copyright}</p>
                    <div className="footer-440__legal">
                        {legalLinks.map((link) => (
                            <a key={link.label} href={link.href} className="footer-440__legal-link" target="_top">
                                {link.label}
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </footer>
    );
}
